<script>
import Sidebar from "./components/Sidebar/Sidebar.vue";
import axios from 'axios'

// import FileComponent from './components/FileComponent';
    



export default {
  
  components: { Sidebar},
  mounted() {
    for (let [key, value] of Object.entries(this.$store.state)) {
      // console.log(`${key}: ${value}`);
      value = localStorage.getItem(key);
      this.$store.commit("setTaskCompletionState", {
        varname: key,
        state: value,
      });
    }
    // if you want to clear your local store for this site, input window.localStorage.clear(); into chrome dev tool console while on the website
  },
  data() {
    return {
      filesrcs: [
        {
          title: 'LsgOhr1-6.jpeg',
          src: require('@/assets/Loesungen/LsgOhr1-6.jpeg'),
        },
        {
          title: 'LsgOhr7-14.jpeg',
          src: require('@/assets/Loesungen/LsgOhr7-14.jpeg'),
        },
        {
          title: 'LsgOhr15-23.jpeg',
          src: require('@/assets/Loesungen/LsgOhr15-23.jpeg'),
        },
        {
          title: 'LsgOhr24-31.jpeg',
          src: require('@/assets/Loesungen/LsgOhr24-31.jpeg'),
        },
        {
          title: 'LsgAudio1.jpeg',
          src: require('@/assets/Loesungen/LsgAudio1.jpeg'),
        },
        {
          title: 'LsgAudio2-4.jpeg',
          src: require('@/assets/Loesungen/LsgAudio2-4.jpeg'),
        },
        {
          title: 'LsgAudio5-9.jpeg',
          src: require('@/assets/Loesungen/LsgAudio5-9.jpeg'),
        },
        {
          title: 'LsgAudio10-13.jpeg',
          src: require('@/assets/Loesungen/LsgAudio10-13.jpeg'),
        },
        {
          title: 'LsgAudio14-18.jpeg',
          src: require('@/assets/Loesungen/LsgAudio14-18.jpeg'),
        },
        {
          title: 'LsgAudio19-23.jpeg',
          src: require('@/assets/Loesungen/LsgAudio19-23.jpeg'),
        },
        {
          title: 'LsgAudio24-27.jpeg',
          src: require('@/assets/Loesungen/LsgAudio24-27.jpeg'),
        },
        {
          title: 'LsgAudio28-31.jpeg',
          src: require('@/assets/Loesungen/LsgAudio28-31.jpeg'),
        },
        {
          title: 'LsgAudio32-34.jpeg',
          src: require('@/assets/Loesungen/LsgAudio32-34.jpeg'),
        },

      ],
    }
  },
  methods: {
    forceFileDownload(response, title) {
      console.log(title)
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', title)
      document.body.appendChild(link)
      link.click()
    },
    downloadWithAxios(url, title) {
      axios({
        method: 'get',
        url,
        responseType: 'arraybuffer',
      })
        .then((response) => {
          this.forceFileDownload(response, title)
        })
        .catch(() => console.log('error occured'))
    },
  }







};



</script>
<template>
  <nav class="navbar fixed-top navbar-expand-lg navbar-dark bg-dark">
    <a class="navbar-brand" href="#">MeteOhr</a>
    <button
      class="navbar-toggler"
      type="button"
      data-toggle="collapse"
      data-target="#navbarNav"
      aria-controls="navbarNav"
      aria-expanded="false"
      aria-label="Toggle navigation"
    >
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarNav">
      <ul class="navbar-nav mr-auto">
        <li class="nav-item ml-3 mr-3">Projekt Medienerstellung WS21/22</li> 
       
        
      </ul>

      <ul class="navbar-nav" align="right">
         <li class="nav-item ml-3 mr-3">
          <a class="nav-link dropdown-toggle" href="#" id="navbarDropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          Hilfe
          </a>
          <div align ="right" class="dropdown-menu mr-5  dropdown-menu-right" aria-labelledby="navbarDropdownMenuLink" style="width: 40%">
             <span class="dropdown-item-text">
               	Bei <b>Darstellungsproblemen</b> bitte die <b>Zoom-Funktion</b> des Browser nutzen <br>
                und den Viewport anpassen. Außerdem sollte idealerweise <b>Chrome oder Firefox</b> <br>
                als Browser genutzt werden. <br>
              </span>
              
              <span class="dropdown-item-text mt-4">
               	  Falls es Probleme beim Lösen der Aufgaben gibt, können hier die Lösungen als PDF <br>
                  heruntergeladen werden. <br>
                  <br>
                  <div align="center">
                    <v-flex v-for="(filesrc, index) in filesrcs" :key="index" xs12 md4>
                      <v-card @click="downloadWithAxios(filesrc.src, filesrc.title)" class="btn btn-secondary m-1" style="width:60%">
                        <v-list>
                          <v-list-item>
                            <v-list-item-title>{{ filesrc.title }}</v-list-item-title>
                            <v-list-item-icon>
                              <v-icon class="primary--text"> Download</v-icon>
                            </v-list-item-icon>
                          </v-list-item>
                        </v-list>
                      </v-card>
                    </v-flex>
                    <!-- <FileComponent></FileComponent> -->
                   <br>
                  </div>
                  
              </span>
          </div>
        </li>
        <li class="nav-item ml-3 mr-3">
          <a class="nav-link dropdown-toggle" href="#" id="navbarDropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          About
          </a>
          <div align ="right" class="dropdown-menu ml-3  dropdown-menu-right" aria-labelledby="navbarDropdownMenuLink" style="background-color: primary">
             <span class="dropdown-item-text">
               Diese Website ist Teil der <b>Advanced Projects at the Quality and Usability Lab</b> <br>
               an der TU Berin. <br>
               <br>
               Sie dient als interaktives Tool, um im Modul 'Einführung in die Medieninformatik' <br>
               die Kapitel 3 & 4 näher zu bringen und eine neue, vielleicht angewandtere, Sichtweise <br>
               auf die vermittelten Themen zu liefern und das Gelernte zu vertiefen.
               </span>
          </div>
        </li>

      </ul>





      <div align="right">
        <button type="button" class="btn btn-secondary" data-toggle="modal" data-target="#exampleModal" >
          Impressum
        </button>
      </div>
    </div>
  </nav>



    <div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Impressum</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body" align="center">
            Interaktives Medienprojekt WiSe 21/22 unter der Leitung von Prof. Dr.-Ing. Möller<br>
            Simon Büchner, Luisa Lienicke, My Linh Pham, Frederik Lang <br>
            Straße des 17. Juni 135 <br>
            10623 Berlin <br>
          </div>
          <div class="modal-footer">

            
          </div>
        </div>
      </div>
    </div>

  <div>
    <Sidebar />
    <div :style="{ 'margin-left': sidebarWidth }">
      <router-view />
    </div>
  </div>
</template>

<style>
#logo {
  padding-top: 35px;
}
.navbar {
  position: fixed;
}
.nav-item {
  /* margin-top: 20px; */
  color: lightgrey;
}
.toggle {
  background-color: #528382;
}
html {
  background-color: #e0e0e0;
}
.button {
  color: #528382;
}
.carousel-control-prev {
  /* border-radius: 0px 50px 50px 0px; */
  background-color: #528382;
  /* background-image: linear-gradient(90deg, #528382 0%, #ffffff 90%); */
}
.carousel-control-next {
  /* border-radius:  50px 0px 0px 50px; */
  background-color: #528382;
  /* background-image: linear-gradient(270deg, #528382 0%, #ffffff 90%); */
}

.carousel-indicators {
  background-color: #829695;
  border-radius: 10px;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /*background-color: #e2b0a1;*/
  background-color: #e0e0e0;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}

#carouselExampleIndicators {
  left: 300px;
  width: 1400px;
  height: 800px;
  background-color: #ffffff;
}
h1 {
  /* padding: 30px; */
  padding-top: 60px;
}

/* .Überschriften {
  position: absolute;
  top: 10px;
  left: 300px;
} */

.carousel-control-prev {
  width: 50px;
}
.carousel-control-next {
  width: 50px;
}
.carousel-item {
  padding: 70px;
  padding-left: 130px;
  padding-right: 130px
}
.carousel-inner {
  height: 800px;
}
</style>
